import { SessionManagementMsg, SessionManagement_update, SessionManagement_SessionManagementModel_token__39A60A33, InactivityConfig_create_Z5C7ECD40, SessionManagement_init } from "../Session.js";
import { Common_EmailAddress_value_Z39D6D3C1, Common_EmailAddress_create_Z721C83C5, Security_ResetPasswordViewModel, Security_LoginViewModel, Security_AuthErrorMessage_get_describe, Security_EmailChangeViewModel_get_empty, Security_ResetPasswordViewModel_get_empty, Security_RegisterViewModel_get_empty, Security_LoginViewModel_get_empty } from "../fable_modules/Webbler.Models.1.3.1/Api.fs.js";
import { InactivityModel_get_isActive_, Model_get_inactivity_, InactivityModel_get_loggedOut, InactivityModel_get_warning, Msg, Model, InactivityModel_get_init } from "./AuthTypes.js";
import { Cmd_none, Cmd_map, Cmd_batch } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { ofArray, singleton } from "../fable_modules/fable-library-js.4.25.0/List.js";
import { success, error } from "../ThreeDocs.SharedUI/Toast.js";
import { some, map, defaultArg } from "../fable_modules/fable-library-js.4.25.0/Option.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.25.0/String.js";
import { Compose_Lens, Compose_Lens_op_GreaterMinusGreater_31E453EA, Optic_Set, Optic_Set_op_HatEquals_2170E4F5 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { Cmd_OfAsyncWith_attempt, Cmd_OfAsyncWith_either } from "../fable_modules/Fable.Elmish.4.4.0/cmd.fs.js";
import { AsyncHelpers_start } from "../fable_modules/Fable.Elmish.4.4.0/prelude.fs.js";
import { securedAuthApi, publicAuthApi } from "../Api.js";
import { Navigation_newUrl } from "../fable_modules/Fable.Elmish.Browser.4.1.0/navigation.fs.js";
import { Page, AuthPage, pageHash } from "../Pages.js";

export function init() {
    const patternInput = SessionManagement_init(undefined, InactivityConfig_create_Z5C7ECD40(10 * 60, 60));
    return [new Model(Security_LoginViewModel_get_empty(), Security_RegisterViewModel_get_empty(), Security_ResetPasswordViewModel_get_empty(), Security_EmailChangeViewModel_get_empty(), "", undefined, patternInput[0], false, InactivityModel_get_init(), false), Cmd_batch(ofArray([singleton((dispatch) => {
        dispatch(new Msg(7, []));
    }), Cmd_map((Item) => (new Msg(19, [Item])), patternInput[1])]))];
}

const errorToast = (() => {
    const f1 = Security_AuthErrorMessage_get_describe();
    return (arg) => error(f1(arg));
})();

function maybeWithToken(f) {
    return (arg_1) => defaultArg(map(f, SessionManagement_SessionManagementModel_token__39A60A33(arg_1)), Cmd_none());
}

export function update(msg, model) {
    let l, bind$0040_1;
    switch (msg.tag) {
        case 0: {
            console.error(some(toText(printf("Error: %O"))(msg.fields[0])));
            return [model, Cmd_none()];
        }
        case 19: {
            const msg_1 = msg.fields[0];
            const patternInput = SessionManagement_update(() => false, msg_1, model.sessionManagement);
            const patternInput_1 = (msg_1.tag === 7) ? [InactivityModel_get_warning(), singleton((dispatch) => {
                dispatch(new Msg(20, [true]));
            })] : ((msg_1.tag === 8) ? [InactivityModel_get_loggedOut(), singleton((dispatch_1) => {
                dispatch_1(new Msg(6, []));
            })] : [model.inactivity, Cmd_none()]);
            return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, model.userInfo, patternInput[0], model.hideResetEmail, patternInput_1[0], model.showPassword), Cmd_batch(ofArray([Cmd_map((Item) => (new Msg(19, [Item])), patternInput[1]), patternInput_1[1]]))];
        }
        case 20:
            return [Optic_Set_op_HatEquals_2170E4F5(new Optic_Set(), (l = Model_get_inactivity_(), Compose_Lens_op_GreaterMinusGreater_31E453EA(new Compose_Lens(), InactivityModel_get_isActive_())(l)))(msg.fields[0])(model), Cmd_none()];
        case 1:
            return [new Model(model.loginVM, msg.fields[0](model.registerVM), model.resetVM, model.emailChangeVm, model.resetRequestEmail, model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_none()];
        case 2:
            return [new Model(msg.fields[0](model.loginVM), model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_none()];
        case 3:
            return [new Model(model.loginVM, model.registerVM, msg.fields[0](model.resetVM), model.emailChangeVm, model.resetRequestEmail, model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_none()];
        case 4:
            return [new Model(new Security_LoginViewModel(model.loginVM.email, ""), model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_OfAsyncWith_either((x) => {
                AsyncHelpers_start(x);
            }, publicAuthApi.login, model.loginVM, (Item_1) => (new Msg(5, [Item_1])), (Item_2) => (new Msg(0, [Item_2])))];
        case 5: {
            const r = msg.fields[0];
            if (r.tag === 1) {
                return [model, errorToast(r.fields[0])];
            }
            else if (r.fields[0].tag === 1) {
                return [new Model(model.loginVM, model.registerVM, (bind$0040_1 = model.resetVM, new Security_ResetPasswordViewModel(model.loginVM.email, r.fields[0].fields[0], bind$0040_1.newPassword, bind$0040_1.confirmPassword)), model.emailChangeVm, model.resetRequestEmail, undefined, model.sessionManagement, true, model.inactivity, model.showPassword), Cmd_batch(ofArray([singleton((dispatch_4) => {
                    dispatch_4(new Msg(19, [new SessionManagementMsg(2, [])]));
                }), Navigation_newUrl(pageHash(new Page(0, [new AuthPage(1, [undefined])])))]))];
            }
            else {
                return [model, Cmd_batch(ofArray([singleton((dispatch_2) => {
                    dispatch_2(new Msg(19, [new SessionManagementMsg(1, [r.fields[0].fields[0]])]));
                }), singleton((dispatch_3) => {
                    dispatch_3(new Msg(7, []));
                })]))];
            }
        }
        case 7:
            return [model, maybeWithToken((t_2) => Cmd_OfAsyncWith_either((x_1) => {
                AsyncHelpers_start(x_1);
            }, securedAuthApi(t_2).getUserInfo, undefined, (Item_4) => (new Msg(8, [Item_4])), (Item_5) => (new Msg(0, [Item_5]))))(model.sessionManagement)];
        case 8: {
            const r_1 = msg.fields[0];
            if (r_1.tag === 1) {
                return [model, errorToast(r_1.fields[0])];
            }
            else {
                return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, r_1.fields[0], model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), singleton((dispatch_5) => {
                    dispatch_5(new Msg(18, []));
                })];
            }
        }
        case 6:
            return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, undefined, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_batch(ofArray([maybeWithToken((t_3) => Cmd_OfAsyncWith_either((x_2) => {
                AsyncHelpers_start(x_2);
            }, securedAuthApi(t_3).logout, undefined, (Item_6) => (new Msg(9, [Item_6])), (Item_7) => (new Msg(0, [Item_7]))))(model.sessionManagement), singleton((dispatch_6) => {
                dispatch_6(new Msg(19, [new SessionManagementMsg(2, [])]));
            }), Navigation_newUrl(pageHash(new Page(0, [new AuthPage(0, [])])))]))];
        case 9:
            if (msg.fields[0].tag === 1) {
                return [model, Cmd_none()];
            }
            else {
                return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, undefined, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_none()];
            }
        case 10:
            return [model, Cmd_OfAsyncWith_either((x_3) => {
                AsyncHelpers_start(x_3);
            }, publicAuthApi.register, model.registerVM, (Item_8) => (new Msg(11, [Item_8])), (Item_9) => (new Msg(0, [Item_9])))];
        case 11: {
            const r_3 = msg.fields[0];
            if (r_3.tag === 1) {
                return [model, errorToast(r_3.fields[0])];
            }
            else {
                return [model, Cmd_batch(ofArray([success("Success"), Navigation_newUrl(pageHash(new Page(0, [new AuthPage(0, [])])))]))];
            }
        }
        case 12:
            return [model, Cmd_OfAsyncWith_either((x_4) => {
                AsyncHelpers_start(x_4);
            }, publicAuthApi.resetPasswordWithToken, model.resetVM, (Item_10) => (new Msg(13, [Item_10])), (Item_11) => (new Msg(0, [Item_11])))];
        case 13: {
            const r_4 = msg.fields[0];
            if (r_4.tag === 1) {
                return [model, errorToast(r_4.fields[0])];
            }
            else {
                return [model, Cmd_batch(ofArray([success("Success, please log in with your new password"), Navigation_newUrl(pageHash(new Page(0, [new AuthPage(0, [])])))]))];
            }
        }
        case 14:
            return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, msg.fields[0], model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_none()];
        case 15: {
            const matchValue = Common_EmailAddress_create_Z721C83C5(model.resetRequestEmail);
            if (matchValue.tag === 1) {
                return [model, error("Invalid e-mail address entered")];
            }
            else {
                return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, "", model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, model.showPassword), Cmd_batch(ofArray([Cmd_OfAsyncWith_attempt((x_5) => {
                    AsyncHelpers_start(x_5);
                }, publicAuthApi.requestPasswordResetTokenEmail, Common_EmailAddress_value_Z39D6D3C1(matchValue.fields[0]), (Item_12) => (new Msg(0, [Item_12]))), success("An email has been sent to the specified address"), Navigation_newUrl(pageHash(new Page(0, [new AuthPage(0, [])])))]))];
            }
        }
        case 16: {
            const matchValue_1 = Common_EmailAddress_create_Z721C83C5(model.emailChangeVm.currentEmail);
            const matchValue_2 = Common_EmailAddress_create_Z721C83C5(model.emailChangeVm.newEmail);
            const copyOfStruct = matchValue_1;
            if (copyOfStruct.tag === 1) {
                return [model, error("Invalid current email address")];
            }
            else {
                const copyOfStruct_1 = matchValue_2;
                if (copyOfStruct_1.tag === 1) {
                    return [model, error("Invalid new email address")];
                }
                else {
                    return [model, Cmd_OfAsyncWith_either((x_6) => {
                        AsyncHelpers_start(x_6);
                    }, publicAuthApi.emailChangeWithToken, model.emailChangeVm, (Item_13) => (new Msg(17, [Item_13])), (Item_14) => (new Msg(0, [Item_14])))];
                }
            }
        }
        case 17: {
            const r_5 = msg.fields[0];
            return [model, (r_5.tag === 1) ? errorToast(r_5.fields[0]) : Cmd_batch(ofArray([success("Email successfully changed"), Navigation_newUrl(pageHash(new Page(0, [new AuthPage(0, [])])))]))];
        }
        case 21:
            return [new Model(model.loginVM, model.registerVM, model.resetVM, model.emailChangeVm, model.resetRequestEmail, model.userInfo, model.sessionManagement, model.hideResetEmail, model.inactivity, msg.fields[0]), Cmd_none()];
        default:
            return [model, Cmd_none()];
    }
}

